import React from 'react';
import { connect } from 'react-redux';
import * as actions from '../../Actions/matchables';
import cssClasses from './transaction.css';

const UnmatchTransaction = ({ account, bookId, dateRange, deleteMatchItem, onClose, status, transDetails, uncodeTransaction }) => {

    const UnmatchText = [
        <p style={{marginBottom:10}}>You are unmatching the transaction,</p>,
        'do you also want to delete the transaction from Reckon Hosted?',
        <br/>
    ]

    const onUnmatch = () => {
      uncodeTransaction(transDetails);
      onClose();
    }

    const onDelete = () => {
      deleteMatchItem(transDetails)
      onClose();
    }

    return (
        <div className={cssClasses.modal_padding}>
            <div>
                <h4 style={{ marginTop: 'auto' }}>Unmatch Transaction</h4>
                <div style={{textAlign: 'center', margin: 10}}>{UnmatchText}</div>
                <hr style={{ marginBottom: 13, marginTop: 15 }}/>
                <div style={{display: 'flex', justifyContent: 'space-between'}}>
                    <div><button type="button" className={[cssClasses.btn, cssClasses.btnSecondary, cssClasses.btn_margin].join(' ')} onClick={onClose}>Cancel</button></div>
                    <div>
                        <button type="button" className={[cssClasses.btn, cssClasses.btnPrimary, cssClasses.btn_margin].join(' ')} onClick={onUnmatch}>Unmatch</button>
                        <button type="button" disabled={transDetails.isSaving} className={[cssClasses.btn, cssClasses.btnDanger].join(' ')} onClick={onDelete}>Delete</button>
                    </div>
                </div>
            </div>
        </div>
        );
    }    

function mapStateToProps(state) {
    return {
      status: state.status,
    };
  }
  
export default connect(mapStateToProps, actions)(UnmatchTransaction);


// WEBPACK FOOTER //
// ./src/components/Transaction/UnmatchTransaction.js